import axios from 'axios';
import {flashMessage} from 'redux-flash';
import Config from '../../config';
import {ProcessContentFields, ProcessContentStatusFields} from '../../helpers/CoreHelpers';
import contentDefinitionTypes from '../../config/contentDefinitionTypes';
import {getWidgetList} from './block';
import _ from 'lodash';

export function filter(items) {
    return (dispatch) => {
        dispatch({
            type: 'CONTENT_FILTER',
            payload: {
                data: items
            }
        });

        return Promise.resolve(items);
    }
}

export function setContentDefinition(definition) {
    return (dispatch) => {
        dispatch({
            type: 'CONTENT_SET_DEFINITION',
            payload: {
                definition: definition
            }
        });
    }
}

export function copyPage(values, languageCode) {
    return (dispatch) => {
        dispatch({
            type: '@@redux-form/INITIALIZE',
            meta: {
                form: 'ContentForm',
                keepDirty: undefined
            },
            payload: {
                ...values,
                languageId: languageCode
            }
        });
    }
}

export function move(id, languageCode, values) {
    return (dispatch) => {
        return axios.put(Config.api.endpoint + 'api/content/' + id + '/move', values, Config.getApiConfig()).then(response => {
            if (response.data) {
                dispatch(single(id, languageCode));

                dispatch({
                    type: 'CONTENT_MOVE_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch(flashMessage('Content moved!', {timeout: 3000, props: {type: 'success'}}));

                return response;
            }
        })
    }
}

export function single(id, languageCode, languages, parse = false, backOffice = false) {
    return (dispatch) => {
        const queryParams = {
            parse: parse,
            backOffice: backOffice
        };

        const queryParamsString = new URLSearchParams(queryParams).toString();

        return axios.get(`${Config.api.endpoint}api/content/${id}/${languageCode}?${queryParamsString}`, Config.getApiConfig()).then(response => {
            if (response.data) {
                if (parse === false) {
                    return axios.get(Config.api.endpoint + 'api/Content/definition/' + response.data.contentDefinitionKey, Config.getApiConfig()).then(definition => {
                        const values = {};

                        values.id = response.data.id;
                        values.parentContentId = response.data.parentContentId;
                        values.parentWorkspaceId = response.data.parentWorkspaceId;
                        values.contentVisibilityId = response.data.contentVisibilityId;
                        values.contentDefinitionKey = response.data.contentDefinitionKey;
                        values.title = response.data.title;
                        values.widgets = response.data.widgets;
                        values.published = response.data.published ? "true" : "false";
                        values.publishDate = response.data.publishDate;
                        values.unpublishDate = response.data.unpublishDate;
                        values.usage = response.data.usage;

                        const languageContentFields = {};

                        languages.forEach((language) => {
                            const find = _.find(response.data.languageContentFields, (item) => item.language.code === language.id);

                            if (find) {
                                languageContentFields[language.id] = {
                                    data: ProcessContentFields(find.contentFields),
                                    language: {
                                        code: language.id,
                                        title: language.title
                                    },
                                    enabled: ProcessContentStatusFields(find.contentFields)
                                };
                            } else {
                                languageContentFields[language.id] = {
                                    data: {},
                                    language: {
                                        code: language.id,
                                        title: language.title
                                    },
                                    enabled: {},
                                };
                            }
                        });

                        values.languageContentFields = languageContentFields;

                        dispatch({
                            type: 'CONTENT_SINGLE_SUCCESS',
                            payload: {
                                title: response.data.title,
                                definition: definition.data,
                                data: response.data
                            }
                        });

                        return {
                            values: values,
                            data: response.data
                        };
                    });
                } else {
                    dispatch({
                        type: 'CONTENT_SINGLE_SUCCESS',
                        payload: {
                            data: response.data
                        }
                    });

                    return response
                }
            }
        })
    }
}

export function patch(id, languageCode, languages, values) {
    return (dispatch) => {
        return axios.patch(Config.api.endpoint + 'api/content/' + id + '/' + languageCode + '?removeMissingFields=true', values, Config.getApiConfig()).then(response => {
            if (response.data) {
                let contentType = "Content";

                switch (values.contentDefinitionType) {
                    case contentDefinitionTypes.BLOCK:
                        contentType = "Block";
                        break;
                    case contentDefinitionTypes.PAGE:
                        contentType = "Page";
                        break;
                    case contentDefinitionTypes.WIDGET:
                        contentType = "Widget";
                        dispatch(getWidgetList(languageCode));
                        break;
                    default:
                        break;
                }

                dispatch(single(id, languageCode, languages, false, true));

                dispatch({
                    type: 'CONTENT_PATCH_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                if (values.published && (values.contentDefinitionType === contentDefinitionTypes.BLOCK || values.contentDefinitionType === contentDefinitionTypes.PAGE)) {
                    dispatch(flashMessage(`${contentType}: ${values.title} has been sucessfully published!`, { timeout: 3000, props: { type: 'publish' } }));
                } else {
                    dispatch(flashMessage('Content updated!', {timeout: 3000, props: {type: 'success'}}));
                }

                return response;
            }
        })
    }
}

export function put(id, languageCode, values) {
    return (dispatch) => {
        return axios.put(Config.api.endpoint + 'api/content/' + id + '/' + languageCode + '/publish', values, Config.getApiConfig()).then(response => {
            if (response.data) {
                dispatch({
                    type: 'CONTENT_PUT_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch(flashMessage('Content published!', {timeout: 3000, props: {type: 'success'}}));

                return response;
            }
        })
    }
}

export function post(languageCode, languages, values) {
    return (dispatch) => {
        return axios.post(Config.api.endpoint + 'api/content/' + languageCode + '/new', values, Config.getApiConfig()).then(response => {
            if (response.data) {
                dispatch({
                    type: 'CONTENT_POST_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch(single(response.data.id, languageCode, languages, false, true));

                dispatch(flashMessage('Content created!', {timeout: 3000, props: {type: 'success'}}));

                return response;
            }
        })
    }
}

export function definition(contentDefinitionKey) {
    const request = Config.api.endpoint + 'api/Content/definition/' + contentDefinitionKey;

    if (contentDefinitionKey) {
        return (dispatch) => {
            return axios.get(request, Config.getApiConfig()).then(response => {
                if (response.data) {
                    dispatch({
                        type: 'CONTENT_DEFINITION_SUCCESS',
                        payload: {
                            data: response.data
                        }
                    });

                    return response;
                }
            })
        }
    }
}

export function structure(parentWorkspaceId = false, skipStore = false) {
    let url;

    if (parentWorkspaceId) {
        url = Config.api.endpoint + 'api/Content/structure/' + parentWorkspaceId + '/page';
    } else {
        url = Config.api.endpoint + 'api/Content/structure/page';
    }

    return (dispatch) => {
        dispatch({
            type: 'MENU_START_GET',
            payload: {
                type: 'pages'
            }
        });

        dispatch({
            type: 'CONTENT_STRUCTURE_LOADING',
            payload: true
        });

        return axios.get(url, Config.getApiConfig({'Cache-Control': 'no-cache'})).then(response => {
            if (response.data) {
                dispatch({
                    type: 'MENU_STOP_GET',
                    payload: true
                });

                dispatch({
                    type: 'CONTENT_STRUCTURE_SUCCESS',
                    payload: {
                        data: response.data,
                        parentWorkspaceId: parentWorkspaceId,
                        skipStore: skipStore
                    }
                });

                return response;
            }
        })
    }
}

export function destroy(id, type) {
    const request = `${Config.api.endpoint}api/${type === 'widget' ? 'Widget' : 'Content'}/${id}`;

    return (dispatch) => {
        return axios.delete(request, Config.getApiConfig()).then(response => {
            if (response.data) {
                dispatch({
                    type: 'CONTENT_DESTROY_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch(flashMessage('Content deleted!', {timeout: 3000, props: {type: 'success'}}));

                return response;
            }
        })
    }
}

export function pageView(contentId, url) {
    let postData = {
        contentId: contentId,
        url: url,
    };

    return (dispatch) => {
        return axios.post(Config.api.endpoint + 'api/Content/pageview', postData, Config.getApiConfig()).then(response => {
            if (response.data) {
                dispatch({
                    type: 'CONTENT_POST_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch(flashMessage('Content created!', {timeout: 3000, props: {type: 'success'}}));

                return response;
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/core/store/actions/content.js